export const ACTION_GENERATE_JOB_POSTING_DESCRIPTION = 'generate_job_posting_description';
export const ACTION_GENERATE_REJECTION_FEEDBACK = 'generate_rejection_feedback';
export const ACTION_GENERATE_INTERVIEW_SCRIPT = 'generate_interview_script';
export const ACTION_GENERATE_SCREENING_QUESTIONS = 'generate_screening_questions';
export const ACTION_GENERATE_PRACTICAL_TECHNICAL_CASE = 'generate_practical_technical_case';
export type SinapseAction =
  | typeof ACTION_GENERATE_JOB_POSTING_DESCRIPTION
  | typeof ACTION_GENERATE_REJECTION_FEEDBACK
  | typeof ACTION_GENERATE_INTERVIEW_SCRIPT
  | typeof ACTION_GENERATE_SCREENING_QUESTIONS
  | typeof ACTION_GENERATE_PRACTICAL_TECHNICAL_CASE
  | 'text'
  | 'audio';

export const COMPETENCY_MAP = {
  1: 'Gestão de Recursos de Pessoas',
  2: 'Coordenação e Gestão do Tempo',
  3: 'Gestão de Recursos financeiros e Materiais',
  4: 'Gerenciamento de Projetos',
  5: 'Vendas',
  6: 'Comunicação e Marketing de Produtos e Serviços',
  7: 'Experiência do Cliente',
  8: 'Pensamento Analítico',
  9: 'Pensamento Criativo',
  10: 'Pensamento Crítico',
  11: 'Pensamento Sistêmico',
  12: 'Marketing Digital',
  13: 'Software e Linguagem de Programação',
  14: 'Fazendo Perguntas',
  15: 'Ensino e Treinamento',
  16: 'Recebendo FeedBack',
  17: 'Comunicação',
  18: 'Seguindo Instruções e Procedimentos',
  19: 'Auxiliar e apoiar os colegas de trabalho',
  20: 'Empatia',
  21: 'Persuasão e Negociação',
  22: 'Relacionamento e Networking',
  23: 'Demonstrando Consideração',
  24: 'Liderança Ética',
  25: 'Construindo Confiança',
  26: 'Trabalhar de forma independente',
  27: 'Gerenciamento de tempo e priorização',
  28: 'Autoconsciência Interna',
  29: 'Autoconsciência Externa',
  30: 'Automotivação/Autocontrole',
  31: 'Curiosidade',
  32: 'Adaptação à Mudança',
  33: 'Vontade de Aprender',
  34: 'Cumprimento de Compromissos e Prazos',
  35: 'Assumindo Responsabilidade',
  36: 'Gerenciando a Qualidade',
  37: 'Organização',
  38: 'Gerenciamento de Frustrações',
  39: 'Gerenciamento de Estresse',
  40: 'Persistência',
  41: 'Cultura da empresa',
};
